import script from "./PantallaProduccion.vue?vue&type=script&setup=true&lang=js"
export * from "./PantallaProduccion.vue?vue&type=script&setup=true&lang=js"

import "./PantallaProduccion.vue?vue&type=style&index=0&id=1e88148b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e88148b"]])

export default __exports__